import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { portalApi } from '../../../lib/portalApi';

const FounderContext = createContext(null);

export function FounderProvider({ children, startupId }) {
  const [startup, setStartup] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const s = await portalApi.myStartup();
      setStartup(s);
    } catch {
      setStartup(null);
    } finally {
      setLoading(false);
    }
  }, [startupId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <FounderContext.Provider value={{ startup, loading, refresh, startupId }}>
      {children}
    </FounderContext.Provider>
  );
}

export function useFounder() {
  const ctx = useContext(FounderContext);
  if (!ctx) throw new Error('useFounder must be used within FounderProvider');
  return ctx;
}
